import { Button, Image } from "@chakra-ui/react";
import { logEvent } from "firebase/analytics";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { analytics, firestore } from "../firebase";
import { collection, onSnapshot } from "firebase/firestore";
import { useAtom } from "jotai";
import { Helmet } from "react-helmet";
import { MemberInfo } from "../types/typeDefs";
import logo from "./../Home/nz country.png";
import { TeamMember } from "./TeamMember";
import { windowSizeState } from "../jotai";

export const Team = () => {
  const nav = useNavigate();

  const [teamMembers, setTeamMembers] = useState<Array<MemberInfo>>([]);

  useEffect(() => {
    const unsub = onSnapshot(collection(firestore, `team`), (snapshot) => {
      setTeamMembers([]);
      snapshot.forEach((snapDoc) => {
        setTeamMembers((prev) => {
          return [...prev, { ...snapDoc.data(), id: snapDoc.id } as MemberInfo];
        });
      });
    });

    return unsub;
  }, []);
  useEffect(() => {
    logEvent(analytics, "page_view", { page_title: "Team" });
  }, []);
  const [size] = useAtom(windowSizeState);

  const schema = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Person",
        name: "Mark Lupi",
        jobTitle:
          "Business Owner, Professional Hunting Guide and Firearms Expert",
        worksFor: {
          "@type": "Organization",
          name: "NZ COUNTRY",
        },
        url: "https://www.nzcountry.guide/team",
        image:
          "https://firebasestorage.googleapis.com/v0/b/nzcountry.appspot.com/o/teamImages%2FMark%20Sq.jpg?alt=media",
        email: "mailto:mark@nzcountry.guide",
      },
      {
        "@type": "Person",
        name: "James Ready",
        jobTitle: "Senior Professional Hunting Guide",
        worksFor: {
          "@type": "Organization",
          name: "NZ COUNTRY",
        },
        url: "https://www.nzcountry.guide/team",
        image:
          "https://firebasestorage.googleapis.com/v0/b/nzcountry.appspot.com/o/teamImages%2FJames%20Sq.jpg?alt=media",
      },
      {
        "@type": "Person",
        name: "Aaron Shields",
        jobTitle: "Professional Hunting Guide",
        worksFor: {
          "@type": "Organization",
          name: "NZ COUNTRY",
        },
        url: "https://www.nzcountry.guide/team",
        image:
          "https://firebasestorage.googleapis.com/v0/b/nzcountry.appspot.com/o/teamImages%2FAaron%20Sq.jpg?alt=media",
      },
      {
        "@type": "Person",
        name: "Matthew Hodgson",
        jobTitle: "Professional Hunting Guide",
        worksFor: {
          "@type": "Organization",
          name: "NZ COUNTRY",
        },
        url: "https://www.nzcountry.guide/team",
        image:
          "https://firebasestorage.googleapis.com/v0/b/nzcountry.appspot.com/o/teamImages%2FMatt%20Sq.jpg?alt=media",
      },
      {
        "@type": "Person",
        name: "Ethan Stevenson",
        jobTitle: "Professional Hunting Guide",
        worksFor: {
          "@type": "Organization",
          name: "NZ COUNTRY",
        },
        url: "https://www.nzcountry.guide/team",
        image:
          "https://firebasestorage.googleapis.com/v0/b/nzcountry.appspot.com/o/teamImages%2Fethan_2.73.1.jpg?alt=media",
      },
    ],
  };

  return (
    <>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      </Helmet>
      <div
        style={{
          height: "100vh",
          overflowY: "hidden",
          backgroundColor: "rgba(0,0,0,.95)",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            paddingTop: `${size.height / 20}px`,
            //paddingBottom: `${height / 20}px`,
            //overflowY: "scroll",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              height: `${(size.height / 28) * 3}px`,
              width: "95%",
              maxWidth: "1200px",

              color: "#EA9101",
              fontFamily: "anton",
              fontSize: size.width < 550 ? "30px" : `${size.width / 30}px`,
              borderRadius: "3px",
            }}
          >
            <h1
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                height: "100%",
              }}
            >
              THE HUNT TEAM
            </h1>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              width: "90%",
              maxWidth: "200px",
              justifyContent: "space-between",
            }}
          >
            <Button
              variant="link"
              size="lg"
              color={"#B0B0A0"}
              onClick={() => nav("/")}
              fontFamily={"anton"}
              letterSpacing={1.5}
            >
              Home
            </Button>
            <Button
              variant="link"
              size="lg"
              color={"#B0B0A0"}
              onClick={() => nav("/trophy-hunting-new-zealand")}
              fontFamily={"anton"}
              letterSpacing={1.5}
            >
              Trophy Hunts
            </Button>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              height: `${(size.height / 20) * 15}px`,
              width: "95%",
              maxWidth: "1200px",
              overflowY: "scroll",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
                //backgroundColor: "#70706055",

                borderRadius: "1rem",
              }}
            >
              {teamMembers.length > 0 &&
                teamMembers
                  .sort((a, b) => a.position - b.position)
                  .map((member, idx) => {
                    return <TeamMember teamMember={member} key={idx} />;
                  })}
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                height: "100vh",
                backgroundImage: `url(https://firebasestorage.googleapis.com/v0/b/nzcountry.appspot.com/o/images%2FAndy%20Shooting%20Thar_1.26.1.jpg?alt=media)`,
                backgroundPosition: "center",
                backgroundSize: "cover",
                objectFit: "contain",
                width: "100%",
                maxWidth: "1200px",
                maxHeight: "400px",
                paddingTop: "2rem",
                paddingBottom: "3rem",
              }}
            >
              <div>
                <Image
                  src={logo}
                  width={size.width / 6}
                  style={{
                    width: size.width < 700 ? "250px" : `${size.width / 7}px`,
                  }}
                  loading="eager"
                  onClick={() => nav("/inquire")}
                />
              </div>
              <Button
                variant="outline"
                onClick={() => nav("/inquire")}
                color={"#EA9101"}
                borderColor={"#EA9101"}
              >
                Come hunt with us - Inquire
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
